enum TicketStatus {
    Backlog = "Backlog",
    InProgress = "InProgress",
    WaitingOnSimec = "WaitingOnSimec",
    WaitingForCustomer = "WaitingForCustomer",
    Done = "Done",
    Canceled = "Canceled"
}

export default TicketStatus;